import { IAutomationTask } from './Interfaces';

export interface IAutomationTaskState {
    automationTaskOptions: Array<IAutomationTask>;
    selectedAutomationTaskUri: string | null;
}

export const initialAutomationTaskState: IAutomationTaskState = {
    automationTaskOptions: [],
    selectedAutomationTaskUri: null,
};
